import { Routes } from '@angular/router';
import { LoginAuthGuard, NonLoginAuthGuard, menuGuard } from './guard';
import { customerResolver } from './resolvers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    loadComponent: () => import('./pages/pages.component').then(m => m.PagesComponent),
    canActivateChild: [LoginAuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'dashboard/round-activity',
        loadComponent: () => import('./pages/dashboard/map/map.component').then(m => m.MapComponent)
      },
      {
        path: 'welcome',
        loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'user-management',
        loadComponent: () => import('./pages/management/management.component').then(m => m.ManagementComponent),
        canMatch: [menuGuard]
      },
      {
        path: "user-management/detail/:id",
        loadComponent: () => import('./pages/management/profile/profile.component').then(m => m.ProfileComponent),
        canMatch: [menuGuard]
      },

      {
        path: "admin-user",
        loadComponent: () => import('./pages/admin-user/admin-user.component').then(m => m.AdminUserComponent),
        canMatch: [menuGuard],
        children: [
          {
            path: "admin-management",
            loadComponent: () => import('./pages/admin-user/admin-management/admin-management.component').then(m => m.AdminManagementComponent),
          },
          {
            path: "role-management",
            loadComponent: () => import('./pages/admin-user/role-management/role-management.component').then(m => m.RoleManagementComponent),
          },
          {
            path: "permission/:id",
            loadComponent: () => import('./pages/admin-user/role-management/permission/permission.component').then(m => m.PermissionComponent),
          },
        ]
      },
      {
        path: "course-list-image",
        loadComponent: () => import('./pages/course-list-image/course-list-image.component').then(m => m.CourseListImageComponent),
        canMatch: [menuGuard],
        children: [
          {
            path: ":imageType",
            loadComponent: () => import('./pages/course-list-image/image/image.component').then(m => m.ImageComponent)
          }
        ]
      },
      {
        path: "master",
        loadComponent: () => import('./pages/master/master.component').then(m => m.MasterComponent),
        canMatch: [menuGuard],
        children: [
          {
            path: "skills",
            loadComponent: () => import('./pages/master/skills/skills.component').then(m => m.SkillsComponent)
          },
          {
            path: 'add-skill',
            loadComponent: () => import('./pages/master/add-skill/add-skill.component').then(m => m.AddSkillComponent)
          },
          {
            path: 'edit-skill/:skillID',
            loadComponent: () => import('./pages/master/add-skill/add-skill.component').then(m => m.AddSkillComponent)
          },
          {
            path: "club",
            loadComponent: () => import('./pages/master/club/club.component').then(m => m.ClubComponent)
          },
          {
            path: 'club-type',
            loadComponent: () => import('./pages/master/club-type/club-type.component').then(m => m.ClubTypeComponent),
          },
          {
            path: 'problem-management',
            loadComponent: () => import('./pages/master/report-problem/report-problem.component').then(m => m.ReportProblemComponent)
          },
          {
            path: 'edit-problem-management/:ID',
            loadComponent: () => import('./pages/master/edit-problem-management/edit-problem-management.component').then(m => m.EditProblemManagementComponent),
          },
          {
            path: 'problem-management-child/:ID',
            loadComponent: () => import('./pages/master/problem-child/problem-child.component').then(m => m.ProblemChildComponent),
          },
          {
            path: 'add-child',
            loadComponent: () => import('./pages/master/add-child/add-child.component').then(m => m.AddChildComponent),
          },
          {
            path: 'edit-child/:ID',
            loadComponent: () => import('./pages/master/add-child/add-child.component').then(m => m.AddChildComponent),
          },
          {
            path: 'problem-management-childs/:ID',
            loadComponent: () => import('./pages/master/problem-child-child/problem-child-child.component').then(m => m.ProblemChildChildComponent),
          },
          {
            path: "brand",
            loadComponent: () => import('./pages/master/brand/brand.component').then(m => m.BrandComponent),
          },
          {
            path: 'course-master',
            loadComponent: () => import('./pages/master/course-master/course-master.component').then(m => m.CourseMasterComponent),
          },
          {
            path: 'course-master/map/:courseId',
            loadComponent: () => import('./pages/master/course-master/map/course-map.component').then(m => m.CourseMapComponent),
          },
          {
            path: 'shot-type-master',
            loadComponent: () => import('./pages/master/shot-type-master/shot-type-master.component').then(m => m.ShotTypeMasterComponent),
          },
          {
            path: 'survey',
            loadComponent: () => import('./pages/master/survey-list/survey-list.component').then(m => m.SurveyListComponent),
          },
          {
            path: 'survey/add',
            loadComponent: () => import('./pages/master/survey-list/survey/survey.component').then(m => m.SurveyComponent),
          },
          {
            path: 'survey/edit/:id',
            loadComponent: () => import('./pages/master/survey-list/survey/survey.component').then(m => m.SurveyComponent),
          },
          {
            path: 'widget',
            loadComponent: () => import('./pages/master/widget/widget.component').then(m => m.WidgetComponent),
          },
          {
            path: 'sound-master',
            loadComponent: () => import('./pages/master/sound-master/sound-master.component').then(m => m.SoundMasterComponent),
          },
        ]
      },
      {
        path: "tutorial",
        loadComponent: () => import('./pages/tutorial-management/tutorial-management.component').then(m => m.TutorialManagementComponent),
        canMatch: [menuGuard]
      },
      {
        path: "product-firmware",
        loadComponent: () => import('./pages/product-firmware/product-firmware.component').then(m => m.ProductFirmwareComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'faq',
        loadComponent: () => import('./pages/faq-management/faq-management.component').then(m => m.FaqManagementComponent),
        canMatch: [menuGuard]
      },
      {
        path: "faq/add",
        loadComponent: () => import('./pages/faq-management/question/question.component').then(m => m.QuestionComponent),
        canMatch: [menuGuard]
      },
      {
        path: "faq/edit/:faqID",
        loadComponent: () => import('./pages/faq-management/question/question.component').then(m => m.QuestionComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'report',
        loadComponent: () => import('./pages/support-request/support-request.component').then(m => m.SupportRequestComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'report/detail/:ID',
        loadComponent: () => import('./pages/support-request/support-detail/support-detail.component').then(m => m.SupportDetailComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'customer-service',
        loadComponent: () => import('./pages/customer-service/customer-service.component').then(m => m.CustomerServiceComponent),
        resolve: { customerData: customerResolver },
        canMatch: [menuGuard]
      },
      {
        path: "settings",
        loadComponent: () => import('./pages/settings-control/settings-control.component').then(m => m.SettingsControlComponent),
        canMatch: [menuGuard],
        children: [
          {
            path: 'basic',
            loadComponent: () => import('./pages/settings-control/settings/settings.component').then(m => m.SettingsComponent),
          },
          {
            path: 'basic/edit/:ID',
            loadComponent: () => import('./pages/settings-control/settings/settings-edit/settings-edit.component').then(m => m.SettingsEditComponent),
          },
          {
            path: 'controls',
            loadComponent: () => import('./pages/settings-control/controls/controls.component').then(m => m.ControlsComponent),
          },
        ]
      },
      {
        path: 'all-rounds',
        loadComponent: () => import('./pages/all-round/all-round.component').then(m => m.AllRoundComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./pages/subscription-list/subscription-list.component').then(m => m.SubscriptionListComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'revenue-recognition',
        loadComponent: () => import('./pages/revenue/revenue.component').then(m => m.RevenueComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'subscriptions/details/:id',
        loadComponent: () => import('./pages/subscription-list/subscrition-details/subscrition-details.component').then(m => m.SubscritionDetailsComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pages/notification/notification.component').then(m => m.NotificationComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'notifications/add',
        loadComponent: () => import('./pages/notification/notification-add/notification-add.component').then(m => m.NotificationAddComponent),
        canMatch: [menuGuard]
      },
      {
        path: "notifications/edit/:id",
        loadComponent: () => import('./pages/notification/notification-add/notification-add.component').then(m => m.NotificationAddComponent),
        canMatch: [menuGuard]
      },
      {
        path: "notifications/view/:id",
        loadComponent: () => import('./pages/notification/notification-view/notification-view.component').then(m => m.NotificationViewComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'coupons',
        loadComponent: () => import('./pages/coupon-list/coupon-list.component').then(m => m.CouponListComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'coupons/edit/:id',
        loadComponent: () => import('./pages/coupon-list/coupon/coupon.component').then(m => m.CouponComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'coupons/add',
        loadComponent: () => import('./pages/coupon-list/coupon/coupon.component').then(m => m.CouponComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'arena-entities',
        loadComponent: () => import('./pages/arena-entities/arena-entity-list.component').then(m => m.ArenaEntityListComponent),
      },
      {
        path: 'arena-entities/add',
        loadComponent: () => import('./pages/arena-entities/arena-entity/arena-entity.component').then(m => m.ArenaEntityComponent),
      },
      {
        path: 'arena-entities/edit/:id',
        loadComponent: () => import('./pages/arena-entities/arena-entity/arena-entity.component').then(m => m.ArenaEntityComponent),
      },
      {
        path: 'arena-staff-users',
        loadComponent: () => import('./pages/arena-staff-users/arena-staff-users-list.component').then(m => m.ArenaStaffUsersListComponent),
      },
      {
        path: 'arena-staff-users/add',
        loadComponent: () => import('./pages/arena-staff-users/arena-staff-user-form/arena-staff-user-form.component').then(m => m.ArenaStaffUserFormComponent),
      },
      {
        path: 'arena-staff-users/edit/:id',
        loadComponent: () => import('./pages/arena-staff-users/arena-staff-user-form/arena-staff-user-form.component').then(m => m.ArenaStaffUserFormComponent),
      },
      {
        path: 'product-management',
        loadComponent: () => import('./pages/product-management/product-management.component').then(m => m.ProductManagementComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'product-management/add',
        loadComponent: () => import('./pages/product-management/product-add/product-add.component').then(m => m.ProductAddComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'product-management/edit/:id',
        loadComponent: () => import('./pages/product-management/product-add/product-add.component').then(m => m.ProductAddComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'change-password',
        loadComponent: () => import('./pages/change-password/change-password.component').then(m => m.ChangePasswordComponent),
        canMatch: [menuGuard]
      },

      {
        path: 'user-survey',
        loadComponent: () => import('./pages/user-survey/user-survey.component').then(m => m.UserSurveyComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'user-survey/:USER_ID',
        loadComponent: () => import('./pages/user-survey/user-survey.component').then(m => m.UserSurveyComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'user-survey/details/:ID',
        loadComponent: () => import('./pages/user-survey/survey-details/survey-details.component').then(m => m.SurveyDetailsComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'user-survey/details/:ID/user/:USER_ID',
        loadComponent: () => import('./pages/user-survey/survey-details/survey-details.component').then(m => m.SurveyDetailsComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'cms',
        loadComponent: () => import('./pages/cms/cms.component').then(m => m.CmsComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'cms/edit/:ID',
        loadComponent: () => import('./pages/cms/cms-action/cms-action.component').then(m => m.CmsActionComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'reels',
        loadComponent: () => import('./pages/reels/reels.component').then(m => m.ReelsComponent)
      },
      {
        path: 'reels/content-moderation',
        loadComponent: () => import('./pages/reels/content-moderation.component').then(m => m.ContentModerationComponent)
      },
      {
        path: 'game-votes',
        loadComponent: () => import('./pages/game-votes/game-votes.component').then(m => m.GameVotesComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'game-other-votes',
        loadComponent: () => import('./pages/game-other-votes/game-other-votes.component').then(m => m.GameOtherVotesComponent),
      },
      {
        path: 'feedback',
        loadComponent: () => import('./pages/feedback/feedback.component').then(m => m.FeedbackComponent),
        canMatch: [menuGuard]
      },
      {
        path: 'feedback/details/:id',
        loadComponent: () => import('./pages/feedback/feedback-details/feedback-details.component').then(m => m.FeedbackDetailsComponent),
        canMatch: [menuGuard]
      },
      {
        path: "application-security",
        loadComponent: () => import('./pages/application-security/application-security.component').then(m => m.ApplicationSecurityComponent),
        canMatch: [menuGuard],
        data: { title: 'Application Security', root_name: 'application-security' },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/application-security/suspicious-activities/suspicious-activities.component').then(m => m.SuspiciousActivitiesComponent),
          },
          {
            path: 'blocked',
            loadComponent: () => import('./pages/application-security/blocked/blocked.component').then(m => m.BlockedComponent),
          },
          {
            path: 'whitelisted',
            loadComponent: () => import('./pages/application-security/whitelisted/whitelisted.component').then(m => m.WhitelistedComponent),
          },
          {
            path: 'recaptcha-failures',
            loadComponent: () => import('./pages/application-security/recaptcha-failures/recaptcha-failures.component').then(m => m.RecaptchaFailuresComponent),
          },
          {
            path: 'environment-flags',
            loadComponent: () => import('./pages/application-security/environment-flags/environment-flags.component').then(m => m.EnvironmentFlagsComponent),
          },
          {
            path: 'disposable-emails',
            loadComponent: () => import('./pages/application-security/disposable-emails/disposable-emails.component').then(m => m.DisposableEmailsComponent),
          },
        ]
      },
      {
        path: 'user-device-settings',
        loadComponent: () => import('./pages/user-device-settings/user-device-settings.component').then(m => m.UserDeviceSettingsComponent),
        canMatch: [menuGuard]
      },
      {
        path: "subscription-management",
        loadComponent: () => import('./pages/subscription-management/subscription-management.component').then(m => m.SubscriptionManagementComponent),
        canMatch: [menuGuard],
        data: { title: 'Subscription Management', root_name: 'subscription-management' },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/subscription-management/products/products.component').then(m => m.ProductsComponent),
          },
          {
            path: 'paywall',
            loadComponent: () => import('./pages/subscription-management/paywall/paywall.component').then(m => m.PaywallComponent),
          },
          {
            path: 'paywall/add',
            loadComponent: () => import('./pages/subscription-management/paywall/paywall-manage/paywall-manage.component').then(m => m.PaywallManageComponent),
          },
          {
            path: 'paywall/edit/:id',
            loadComponent: () => import('./pages/subscription-management/paywall/paywall-manage/paywall-manage.component').then(m => m.PaywallManageComponent),
          },
        ]
      },
      {
        path: 'new-features',
        canMatch: [menuGuard],
        loadComponent: () => import('./pages/new-features/new-features.component').then(m => m.NewFeaturesComponent)
      },
      {
        path: 'ai-caddie-feedback',
        canMatch: [menuGuard],
        loadComponent: () => import('./pages/ai-caddie-feedback/ai-caddie-feedback.component').then(m => m.AiCaddieFeedbackComponent)
      },
      {
        path: 'subscription-plan',
        canMatch: [menuGuard],
        loadComponent: () => import('./pages/subscription-plan/subscription-plan.component').then(m => m.SubscriptionPlanComponent)
      },
      {
        path: 'subscription-plan/details/:id',
        loadComponent: () => import('./pages/subscription-plan/details/details.component').then(m => m.DetailsComponent),
        canMatch: [menuGuard]
      },
    ]
  },
  {
    path: '',
    loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
    canActivateChild: [NonLoginAuthGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
      },

      {
        path: 'forgot-password',
        loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  }

];
